import userReducer from './userReducer'
import teamsReducer from './teamsReducer'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
    userReducer,
    teamsReducer
})

export default rootReducer
